<template>
  <v-dialog v-model="show" persistent width="600">
    <v-card>
      <v-card-title>
        {{ $t('announce.upload.title') }}
      </v-card-title>
      <v-card-text>
        <v-file-input
          accept="audio/x-wav,audio/mpeg"
          :rules="[rules.required]"
          show-size
          counter
          small-chips
          persistent-hint
          :hint="$t('announce.upload.hint')"
          :label="$t('announce.upload.file')"
          v-model="file">
        </v-file-input>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('cancel')" text>
          {{ $t('announce.upload.cancel')}}
        </v-btn>
        <v-btn color="primary" :disabled="!ready"
          @click="selectFile" text>
          {{ $t('announce.upload.btnUpload')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'announcements-recording-upload',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      file: null,
      rules: {
        required: val => !!val || this.$t('announce.upload.required')
      }
    }
  },
  computed: {
    ready: function () {
      return !!this.file
    }
  },
  methods: {
    selectFile: function () {
      this.$emit('select-file', this.file)
    }
  }
}
</script>

<style scoped>
</style>
